
import Vue from 'vue';
import MainButton from '@/core/components/MainButton.vue';

export default Vue.extend({
  data() {
    return {
      show_dialog: false,
    };
  },

  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },

  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.show_dialog = value;
      },
    },
  },

  components: {
    MainButton,
  },

  methods: {
    emitResponse(response: boolean): void {
      this.$emit('click', response);
      this.show_dialog = false;
    },
  },
});
